import React from "react";
import { Box, Grid, Typography, IconButton, Link, Stack } from "@mui/material";
import { 
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, 
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaCar, 
  FaTools, FaShower, FaSnowflake 
} from "react-icons/fa";
import goClutchWhite from "../../images/goClutch_White.png"; // Ensure correct path

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        py: 6,
        textAlign: "left",  // Align all content to the left
      }}
    >
      {/* Logo Centered */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <img src={goClutchWhite} alt="GoClutch Logo" width={180} />
      </Box>

      <Grid container spacing={4} sx={{ px: 6 }} justifyContent="space-between">
        
        {/* Our Services */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "orangered", mb: 2 }}>
            Our Services
          </Typography>
          <Stack spacing={1.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaCar size={18} /> <Typography variant="body1">Periodic Services</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaTools size={18} /> <Typography variant="body1">Major Repairs</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaShower size={18} /> <Typography variant="body1">Car Spa & Detailing</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaSnowflake size={18} /> <Typography variant="body1">AC Repair</Typography>
            </Box>
          </Stack>
        </Grid>

        {/* Why Choose Us */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "orangered", mb: 2 }}>
            Why Choose Us?
          </Typography>
          <Stack spacing={1.5}>
            <Typography variant="body1">✅ Expert Mechanics</Typography>
            <Typography variant="body1">✅ Doorstep Service</Typography>
            <Typography variant="body1">✅ Affordable Pricing</Typography>
            <Typography variant="body1">✅ Genuine Spare Parts</Typography>
          </Stack>
        </Grid>

        {/* Service Locations */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "orangered", mb: 2 }}>
            Service Locations
          </Typography>
          <Stack spacing={1.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaMapMarkerAlt size={18} /> <Typography variant="body1">Delhi</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaMapMarkerAlt size={18} /> <Typography variant="body1">Bangalore</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaMapMarkerAlt size={18} /> <Typography variant="body1">Hyderabad</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaMapMarkerAlt size={18} /> <Typography variant="body1">Mumbai</Typography>
            </Box>
          </Stack>
        </Grid>

        {/* Contact Us */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "orangered", mb: 2 }}>
            Contact Us
          </Typography>
          <Stack spacing={1.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaPhone size={18} />
              <Link href="tel:+919133959551" sx={{ textDecoration: "none", color: "#fff", "&:hover": { color: "orangered" } }}>
                <Typography variant="body1">+91 91339 59551</Typography>
              </Link>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaEnvelope size={18} />
              <Link href="mailto:support@goclutch.in" sx={{ textDecoration: "none", color: "#fff", "&:hover": { color: "orangered" } }}>
                <Typography variant="body1">support@goclutch.in</Typography>
              </Link>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FaMapMarkerAlt size={18} /> 
              <Typography variant="body1">Visit our nearest garage</Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      {/* Social Media Links */}
      <Box sx={{ mt: 5, display: "flex", justifyContent: "center", gap: 3 }}>
        <Link href="https://www.facebook.com/goclutch.in/" target="_blank">
          <IconButton sx={{ color: "#fff", "&:hover": { color: "orangered" } }}>
            <FaFacebookF size={22} />
          </IconButton>
        </Link>
        <Link href="https://www.instagram.com/goclutch.in/" target="_blank">
          <IconButton sx={{ color: "#fff", "&:hover": { color: "orangered" } }}>
            <FaInstagram size={22} />
          </IconButton>
        </Link>
        <Link href="https://www.linkedin.com/company/goclutch-in/?viewAsMember=true" target="_blank">
          <IconButton sx={{ color: "#fff", "&:hover": { color: "orangered" } }}>
            <FaLinkedin size={22} />
          </IconButton>
        </Link>
        <Link href="https://x.com/GoClutch1" target="_blank">
          <IconButton sx={{ color: "#fff", "&:hover": { color: "orangered" } }}>
            <FaTwitter size={22} />
          </IconButton>
        </Link>
      </Box>

      {/* Copyright Text */}
      <Typography variant="body2" sx={{ mt: 3, opacity: 0.7, textAlign: "center" }}>
        &copy; {new Date().getFullYear()} | GO CLUTCH PRIVATE LIMITED - ALL RIGHTS RESERVED.
      </Typography>
    </Box>
  );
};

export default Footer;
